import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { jsonToQueryString } from '@vezeeta/web-utils';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Card } from '@vezeeta/web-components'; // eslint-disable-line import/first
import Cookie from 'js-cookie'; // eslint-disable-line import/first

import '../shared/bootstrap.min.css'; // eslint-disable-line import/
import './App.scss';
import '../shared/Utils.scss';
import withCMS from '../components/withCMS/withCMS';
import Payment from './payment/Payment';
import Confirmation from './confirmation/Confirmation';
import Header from './header/Header';
import configurations from './payment/Config';
import { deleteCookies, detectCultureFromDoctorUrl, getDomain, SSLDecision } from '../shared/payment-utils';

class App extends Component {
  componentWillMount() {
    // eslint-disable-next-line no-debugger
    // Force redirect to https if not on local development
    SSLDecision(process.env.REACT_APP_FORCE_HTTPS);
  }
  componentDidMount() {
    if (Cookie.get('PaymentType') === 'reservation') {
      this.CultureLanguage = detectCultureFromDoctorUrl(Cookie.get('CallBack'));
      this.vezeetaUrl = getDomain(Cookie.get('CallBack'), true);
    } else {
      this.CultureLanguage = {
        LanguageId: 1,
        culture: 'en-US',
        RedirectCulture: '/en/',
      };
    }
    this.cookies = ['CD', 'AK', 'TK', 'RK', 'CID', 'PTK', 'CallBack', 'VezeetaUrl', 'LogoClickStatus', 'callBackAttributes'];
  }
  stateCallBack = async () => {
    if (Cookie.get('PaymentType') === 'reservation') {
      const cancelReservationUrl = configurations.cancelReservationUrl;
      const cancelReservationAttributes = {
        reservationKey: Cookie.get('RK'),
      };
      await fetch(`${cancelReservationUrl}${jsonToQueryString(cancelReservationAttributes)}`, {
        method: 'PATCH',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          CountryId: Cookie.get('CD'),
          Language: 'en-US',
        },
      });
    }
    deleteCookies(this.cookies);
    window.location.replace(`//${this.vezeetaUrl}`);
  };
  render() {
    const {
      commonContent, brandKey, calculateUrlForImageAsset,
    } = this.props;
    return (
      <div>
        <Header
          calculateUrlForImageAsset={calculateUrlForImageAsset}
          commonContent={commonContent.websiteHeader}
          onLogoClick={() => {
            if (Cookie.get('LogoClickStatus') !== false) {
              this.stateCallBack(false);
            }
          }}
        />
        <Card>
          <Router history={this.browserHistory}>
            <Switch>
              <Route
                exact
                path="/"
                render={(props) => (
                  <Payment {...props} brandKey={brandKey} />
                )}
              />
              <Route
                path="/check"
                render={(props) => (
                  <Confirmation {...props} />
                )}
              />
            </Switch>
          </Router>
        </Card>
      </div>
    );
  }
}

App.propTypes = {
  brandKey: PropTypes.string,
  commonContent: PropTypes.shape({
    websiteHeader: PropTypes.shape({
      brandLogo: PropTypes.string,
    }),
  }),
  calculateUrlForImageAsset: PropTypes.func.isRequired,
};
App.defaultProps = {
  brandKey: null,
  commonContent: {},
};

export default withCMS(App);



// WEBPACK FOOTER //
// ./src/views/App.js